import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'components/toggle';
import Button from 'shared/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { put } from 'helpers/api';
import Snackbar from 'shared/snackbar';
import Banner from 'shared/banner';

export default function LimitBrokersOnPlugin({ defaultLimit, limit: initialLimit, url }) {
  const [startingLimit, setStartingLimit] = useState(initialLimit);
  const [limit, setLimit] = useState(initialLimit);
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [errors, setErrors] = useState([]);

  function toggleLimit() {
    if (limit === null) {
      setLimit(defaultLimit);
    } else {
      setLimit(null);
    }
  }

  async function saveChanges() {
    setIsSaving(true);
    setErrors([]);
    const payload = { plugins_plugin_set: { broker_limit: limit } };
    try {
      await put(url, payload);
      setStartingLimit(limit);
      setShowSuccessSnackbar(true);
    } catch (error) {
      setErrors(error);
    } finally {
      setIsSaving(false);
    }
  }

  const tooltip = (
    <Tooltip id="plugin-default-tooltip">
      Turning this option on will divide the brokers into multiple pages,
      letting users navigate through data in smaller, manageable chunks.
    </Tooltip>
  );

  return (
    <div className="d-flex flex-column gap-3 mb-5">
      <Snackbar
        show={showSuccessSnackbar}
        text="Updated Broker limit for plugin"
        variant="success"
        onClose={() => setShowSuccessSnackbar(false)}
      />
      <h3 className="m-0 d-inline-flex gap-2 align-items-center">
        Limit Brokers on Plugin
        <OverlayTrigger overlay={tooltip} placement="bottom">
          <FontAwesomeIcon icon={faQuestionCircle}/>
        </OverlayTrigger>
      </h3>
      {errors.length > 0 && (
        <Banner
          content={errors.join('\n')}
          show={errors.length > 0}
          title="The following errors occurred when trying to save. Please fix and re-submit."
          variant="danger"
          onClose={() => setErrors([])}
        />
      )}
      <div className="d-flex align-items-center gap-3">
        <Toggle checked={limit !== null} theme="ds" onChange={toggleLimit}/>
        <span>Limit the amount of brokers that appear on your plugin per page</span>
      </div>

      {limit !== null && (
        <div>
          <label>Broker Limit Per Page</label>
          <input className="form-control" type="number" value={limit} onChange={e => setLimit(e.currentTarget.value)}/>
        </div>
      )}
      {startingLimit !== limit && (
        <div>
          <Button.Primary disabled={isSaving} onClick={saveChanges}>Save</Button.Primary>
        </div>
      )}
    </div>
  );
}

LimitBrokersOnPlugin.propTypes = {
  defaultLimit: PropTypes.number.isRequired,
  limit: PropTypes.number,
  url: PropTypes.string.isRequired,
};
